function getDomain(domains, isCopy) {
    if (!domains) return false;
    const array = domains.split('|');
    let URL = array[0];
    if (typeof window != 'undefined') {
        URL = array.find((d) => (isCopy ? 'ut.' : '') + d === window.location.host) || array[0];
    }
    return URL;
}
function generateSiteUrl({ DOMAINS, ISCOPY, FRONT_URL }) {
    const topLevelDomain = typeof window !== 'undefined' && window.location.host.split('.').pop();
    let URL = getDomain(DOMAINS, ISCOPY);
    let newFront =
        FRONT_URL && FRONT_URL.includes('|')
            ? topLevelDomain == 'com'
                ? FRONT_URL.split('|')[0]
                : FRONT_URL.split('|')[1]
            : FRONT_URL;
    return URL ? `https://${ISCOPY ? 'ut.' : ''}${URL}` : newFront;
}
function generateServerUrl({ DOMAINS, ISCOPY, BACK_URL }) {
    let URL = getDomain(DOMAINS, ISCOPY);
    return URL ? `https://${ISCOPY ? 'at.' : 'api.'}${URL}` : BACK_URL;
}
module.exports = { generateSiteUrl, getDomain, generateServerUrl };
